const STORAGE_KEY = "seiva_support_open"

// Client-side helpers for Support Chat:
//   - sync open state to localStorage (informational; server is source of truth)
//   - Esc closes the panel
//   - Enter on the textarea submits the form; Shift+Enter inserts a newline
const SupportChat = {
  mounted() {
    this.handleEvent("support:state_changed", ({ open }) => {
      localStorage.setItem(STORAGE_KEY, open ? "true" : "false")
    })

    this.syncPanel = () => {
      const panel = this.el.querySelector(".aios-support-panel")
      if (panel && !panel.matches(":popover-open")) {
        try { panel.showPopover() } catch (_error) {}
      }
      const input = panel?.querySelector("textarea")
      const focusIsInPanel = panel?.contains(document.activeElement) || document.activeElement === document.body
      if (panel && (panel !== this.panel || (this.inputDisabled && !input?.disabled && focusIsInPanel))) {
        const focusTarget = input && !input.disabled ? input : panel.querySelector("button[phx-click=close_support]")
        focusTarget?.focus({preventScroll: true})
      }
      if (!panel && this.panel && (this.panel.contains(document.activeElement) || document.activeElement === document.body)) {
        this.el.querySelector("button[phx-click=toggle_support]")?.focus({preventScroll: true})
      }
      this.inputDisabled = input?.disabled
      this.panel = panel
    }
    this.syncPanel()

    this._onKeyDown = (event) => {
      if (event.key === "Escape") {
        const panel = this.el.querySelector(`#${this.el.id}-panel`)
        if (!panel || event.defaultPrevented || !panel.contains(event.target)) return
        event.preventDefault()
        event.stopPropagation()
        this.pushEventTo(this.el, "close_support", {})
        return
      }
    }
    this.el.addEventListener("keydown", this._onKeyDown)

    // Submit on Enter / newline on Shift+Enter, scoped to the textarea inside this widget.
    this._onTextareaKeyDown = (event) => {
      if (event.key !== "Enter" || event.shiftKey || event.isComposing) return
      const ta = event.target
      if (!(ta instanceof HTMLTextAreaElement) || ta.disabled) return
      if (!this.el.contains(ta)) return
      const form = ta.closest("form")
      if (!form) return
      event.preventDefault()
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit()
      } else {
        form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }))
      }
    }
    this.el.addEventListener("keydown", this._onTextareaKeyDown)
  },

  updated() { this.syncPanel() },

  destroyed() {
    if (this._onKeyDown) {
      this.el.removeEventListener("keydown", this._onKeyDown)
    }
    if (this._onTextareaKeyDown) {
      this.el.removeEventListener("keydown", this._onTextareaKeyDown)
    }
  }
}

export default SupportChat
